import { useEffect, useState } from "react";
import { api } from "./api";

export const ISDE_PATH = "/isde-subsidie-kozijnen";
export const ISDE_PREFILL_KEY = "mk_isde_prefill";
export const RVO_CONDITIONS_URL = "https://www.rvo.nl/subsidies-financiering/isde/woningeigenaren/isolatiemaatregelen";

// Subsidieregels komen altijd van de server (beheer → ISDE-subsidies); één keer per sessie opgehaald.
let rulesPromise = null;
export const loadIsdeRules = () => {
  if (!rulesPromise) rulesPromise = api.get("/isde/rules").then((r) => r.data || []).catch(() => { rulesPromise = null; return []; });
  return rulesPromise;
};

export const useIsdeRules = () => {
  const [rules, setRules] = useState(null);
  useEffect(() => {
    let on = true;
    loadIsdeRules().then((r) => on && setRules(r));
    return () => { on = false; };
  }, []);
  return rules;
};

const todayIso = () => new Date().toISOString().slice(0, 10);
export const ruleFor = (rules, status, iso = todayIso()) =>
  (rules || []).find((r) => r.status === status && r.valid_from <= iso && (!r.valid_to || r.valid_to >= iso));
export const nextAnnounced = (rules, iso = todayIso()) =>
  (rules || []).filter((r) => r.status === "voorgenomen" && r.valid_from > iso).sort((a, b) => a.valid_from.localeCompare(b.valid_from))[0];
export const rateOf = (rule, key) => rule?.rates.find((r) => r.key === key)?.amount_per_m2;

export const eur = (v) => new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v);
export const eurRate = (v) => new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v);
export const nlNum = (v) => (v === null || v === undefined ? "" : String(Math.round(v * 100) / 100).replace(".", ","));
export const nlDate = (iso) => (iso ? new Date(`${iso.slice(0, 10)}T12:00:00`).toLocaleDateString("nl-NL", { day: "numeric", month: "long", year: "numeric" }) : "");

export const readIsdePrefill = () => {
  try { return JSON.parse(sessionStorage.getItem(ISDE_PREFILL_KEY) || "null"); } catch { return null; }
};
